/**
 * Single AI-action whitelist for hub intents.
 * The API re-exports this module. Intent cards reference these arrays.
 * Do not copy the map into another file.
 */

const AGENTIC_AI_ACTIONS = new Set([
    'agentic_chat',
    'architecture_desk',
    'generate_agnostic_blueprint',
    'generate_engagement_pack',
    'generate_technologist_advisory',
    'generate_gap_close_proposal',
]);

/** @type {Record<string, string[]>} */
const INTENT_AI_ACTIONS = {
    full: ['agentic_chat', 'generate_agnostic_blueprint', 'generate_engagement_pack', 'generate_technologist_advisory', 'generate_gap_close_proposal'],
    hld: ['agentic_chat', 'generate_agnostic_blueprint', 'generate_technologist_advisory', 'generate_gap_close_proposal'],
    estimate: ['agentic_chat', 'generate_agnostic_blueprint', 'generate_engagement_pack', 'generate_technologist_advisory', 'generate_gap_close_proposal'],
    migration: ['agentic_chat', 'generate_agnostic_blueprint', 'generate_engagement_pack', 'generate_technologist_advisory', 'generate_gap_close_proposal'],
    systems_integration: ['agentic_chat', 'generate_agnostic_blueprint', 'generate_engagement_pack', 'generate_technologist_advisory', 'generate_gap_close_proposal'],
    change_on_platform: ['agentic_chat', 'generate_agnostic_blueprint', 'generate_engagement_pack', 'generate_technologist_advisory', 'generate_gap_close_proposal'],
    iot: ['agentic_chat', 'generate_agnostic_blueprint', 'generate_engagement_pack', 'generate_technologist_advisory', 'generate_gap_close_proposal'],
    scale_deadline: ['agentic_chat', 'generate_agnostic_blueprint', 'generate_engagement_pack', 'generate_technologist_advisory', 'generate_gap_close_proposal'],
    ai_cost: ['agentic_chat', 'generate_engagement_pack', 'generate_technologist_advisory', 'generate_gap_close_proposal'],
    compare: ['agentic_chat'],
    optimize: ['agentic_chat', 'generate_agnostic_blueprint', 'generate_engagement_pack', 'generate_technologist_advisory', 'generate_gap_close_proposal'],
    rfp: ['agentic_chat', 'generate_agnostic_blueprint', 'generate_engagement_pack', 'generate_technologist_advisory', 'generate_gap_close_proposal'],
    review: ['agentic_chat', 'generate_agnostic_blueprint', 'generate_technologist_advisory', 'generate_gap_close_proposal'],
};

/**
 * @param {{ mode?: string, intent?: string|null }} hub
 * @param {string} actionType
 * @returns {{ allowed: boolean, intentId: string }}
 */
function isAiActionAllowedForIntent(hub, actionType) {
    if (!AGENTIC_AI_ACTIONS.has(actionType)) {
        return { allowed: true, intentId: 'full' };
    }
    // Desk is outside hub journeys — always allowed when feature-gated.
    if (actionType === 'architecture_desk') {
        return { allowed: true, intentId: 'desk' };
    }

    const mode = hub?.mode === 'task' ? 'task' : 'full';
    const intentRaw = hub?.intent || null;
    let intentId = 'full';
    if (mode === 'task' && intentRaw && INTENT_AI_ACTIONS[intentRaw]) {
        intentId = intentRaw;
    }

    const allowed = (INTENT_AI_ACTIONS[intentId] || INTENT_AI_ACTIONS.full).includes(actionType);
    return { allowed, intentId };
}

module.exports = {
    AGENTIC_AI_ACTIONS,
    INTENT_AI_ACTIONS,
    isAiActionAllowedForIntent,
};
